export default {
  title: {
    id: 'insurance_policy_details_cancel_auto_renewal_modal_title',
    defaultMessage: 'Cancel auto-renewal',
  },
  confirmationHeading: {
    id: 'insurance_policy_details_cancel_auto_renewal_modal_confirmation_heading',
    defaultMessage: 'Are you sure?',
  },
  description: {
    id: 'insurance_policy_details_cancel_auto_renewal_modal_description',
    defaultMessage:
      'When you cancel auto-renewal, your plan will expire on {endDate, html}. Once you turn it off, you can’t turn it on again.',
  },
  cancelAutoRenewal: {
    id: 'insurance_policy_details_cancel_auto_renewal_modal_cancel_auto_renewal',
    defaultMessage: 'Cancel auto-renewal',
  },
  keepAutoRenewal: {
    id: 'insurance_policy_details_cancel_auto_renewal_modal_keep_auto_renewal',
    defaultMessage: 'Keep auto-renewal',
  },
}
